/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Err_Not_FoundInputs */

const en_rd_err_not_found = /** @type {(inputs: Rd_Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repository not found. It has to be public.`)
};

const id_rd_err_not_found = /** @type {(inputs: Rd_Err_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repo tidak ditemukan. Reponya harus publik.`)
};

/**
* | output |
* | --- |
* | "Repository not found. It has to be public." |
*
* @param {Rd_Err_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_err_not_found = /** @type {((inputs?: Rd_Err_Not_FoundInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Err_Not_FoundInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_err_not_found(inputs)
	return en_rd_err_not_found(inputs)
});